import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';

const ApiUsage = () => {
  const [tavilyUsage, setTavilyUsage] = useState(null);
  const [lushaUsage, setLushaUsage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lushaLoading, setLushaLoading] = useState(true);

  useEffect(() => {
    fetchTavilyData();
    fetchLushaUsage();
  }, []);

  const fetchTavilyData = async () => {
    try {
      setLoading(true);
      const usageResponse = await axios.get('/tavily/usage');
      if (usageResponse.data.success) {
        setTavilyUsage(usageResponse.data.data.summary);
      }
    } catch (error) {
      console.error('Error fetching Tavily data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLushaUsage = async () => {
    try {
      setLushaLoading(true);
      const response = await axios.get('/lusha/account/usage');
      if (response.data.success) {
        setLushaUsage(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching Lusha usage:', error);
    } finally {
      setLushaLoading(false);
    }
  };

  const getUsageStatus = (percentage) => {
    if (percentage >= 100) return { label: 'Limited', color: '#64748b', bg: '#f1f5f9' };
    if (percentage >= 85) return { label: 'Critical', color: '#ef4444', bg: '#fef2f2' };
    if (percentage >= 70) return { label: 'Warning', color: '#f59e0b', bg: '#fffbeb' };
    return { label: 'Healthy', color: '#10b981', bg: '#f0fdf4' };
  };

  const ProviderCard = ({ title, subtitle, icon, color, data, isLoading }) => {
    const status = getUsageStatus(data?.usagePercentage || 0);

    return (
      <div
        className="tm-api-card animate-fade-in"
        style={{
          background: '#fff',
          borderRadius: '16px',
          border: '1px solid #e2e8f0',
          overflow: 'hidden',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
        }}
      >
        <div
          style={{
            padding: '24px',
            borderBottom: '1px solid #f1f5f9',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '10px',
                  background: `${color}15`,
                  color: color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                }}
              >
                <i className={`fas ${icon}`}></i>
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>
                  {title}
                </h3>
                <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#64748b' }}>{subtitle}</p>
              </div>
            </div>
          </div>
          <div
            style={{
              padding: '4px 12px',
              borderRadius: '20px',
              background: status.bg,
              color: status.color,
              fontSize: '11px',
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <span
              style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: 'currentColor',
              }}
            ></span>
            {status.label}
          </div>
        </div>

        <div style={{ padding: '24px' }}>
          {isLoading ? (
            <div
              style={{
                height: '120px',
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'center',
                width: '100%',
              }}
            >
              <div className="spinner"></div>
            </div>
          ) : data ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {/* Progress Section */}
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    alignItems: 'baseline',
                  }}
                >
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#475569' }}>
                    Resource Load
                  </span>
                  <span style={{ fontSize: '20px', fontWeight: '800', color: '#0f172a' }}>
                    {data.usagePercentage}%
                  </span>
                </div>
                <div
                  style={{
                    height: '10px',
                    background: '#f1f5f9',
                    borderRadius: '5px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      height: '100%',
                      width: `${data.usagePercentage}%`,
                      background: color,
                      borderRadius: '5px',
                      transition: 'width 1s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                  ></div>
                </div>
              </div>

              {/* Stats Grid */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div style={{ padding: '16px', background: '#f8fafc', borderRadius: '12px' }}>
                  <div
                    style={{
                      fontSize: '11px',
                      fontWeight: '700',
                      color: '#94a3b8',
                      textTransform: 'uppercase',
                      marginBottom: '4px',
                    }}
                  >
                    Remaining
                  </div>
                  <div style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>
                    {data.creditsRemaining?.toLocaleString()}
                  </div>
                </div>
                <div style={{ padding: '16px', background: '#f8fafc', borderRadius: '12px' }}>
                  <div
                    style={{
                      fontSize: '11px',
                      fontWeight: '700',
                      color: '#94a3b8',
                      textTransform: 'uppercase',
                      marginBottom: '4px',
                    }}
                  >
                    Allocated
                  </div>
                  <div style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>
                    {data.creditsLimit?.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{ padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '13px' }}
            >
              Metrics unavailable
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className="tm-api-usage"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '24px',
      }}
    >
      <ProviderCard
        title="Lusha API"
        subtitle="Enrichment & Extraction"
        icon="fa-database"
        color="#3b82f6"
        data={lushaUsage}
        isLoading={lushaLoading}
      />
      <ProviderCard
        title="Tavily API"
        subtitle="AI Market Search"
        icon="fa-search"
        color="#06b6d4"
        data={tavilyUsage}
        isLoading={loading}
      />
    </div>
  );
};

export default ApiUsage;
